export const GET_PMS_DIT_ACTIVE_YEAR = 'GET_PMS_DIT_ACTIVE_YEAR';
export const GET_PMS_DIT_ACTIVE_YEAR_SUCCESS = 'GET_PMS_DIT_ACTIVE_YEAR_SUCCESS';
export const GET_PMS_DIT_ACTIVE_YEAR_FAILURE = 'GET_PMS_DIT_ACTIVE_YEAR_FAILURE';

